export const PLACE = 'place';
export const TRANSITION = 'transition';
